/**
 * API URL configuration.
 * 
 * Uses REACT_APP_BACKEND_URL from .env file.
 * - For Preview: Set to https://draw-pipeline.preview.emergentagent.com
 * - For Live: Set to empty string (uses relative /api URLs)
 * - For Local: Set to empty string or localhost URL
 */

// Get the backend URL from environment variable (baked in at build time)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const API_BASE_URL = BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export default API;
